import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: {main: '#535b69',},
    secondary: {main: '#00A3E0',}
  }
});